export const endPoints = {
  login: 'admin/login',
  forgotPassword: 'admin/forgot-password-send-otp',
  resetPassword: 'user/reset-password',
  verifyEmail: 'admin/forgot-password-verify-otp',
  updateUserInfo: 'admin/update-user-info',
  listingUsers: 'user',
  admin: (id?: string) => (id ? `admin/${id}` : 'admin'),
  request: 'request',
  upload: (id?: string) => (id ? `uploads/${id}` : 'uploads'),
  bulkAddUsers: 'user/bulk-signup',
  profile: (id?: string) => (id ? `profile/${id}` : 'profile'),
  topic: (id?: string) => (id ? `topic/${id}` : 'topic'),
  topicAdmin: 'topic/admin',
  toggleActivation: (id: string) => `user/${id}/toggle-activation`,
  systemConfig: 'system-config',
  contactUs: (id?: string) => (id ? `contact-us/${id}` : 'contact-us'),
  class: (id?: string) => (id ? `class/${id}` : 'class'),
  listingClasses: 'class/admin',
  approveRequest: (requestId?: string) => `request/approve/${requestId}`,
  rejectRequest: (requestId?: string) => `request/reject/${requestId}`,
  post: (id?: string) => (id ? `post/admin/${id}` : 'post'),
  requestChanges: (requestId?: string) =>
    `request/request-changes/${requestId}`,
  assignRequest: (requestId?: string) => `request/assign/${requestId}`,
  availableUsers: (classId?: string) =>
    classId ? `class/available-users/${classId}` : 'class/available-users',
  togglePublishPost: (postId: string) => `post/publish/${postId}`,
  notificationsUnreadCount: 'notifications/unread-count',
  notifications: 'notifications',
  notificationMarkRead: (id: string) => `notifications/${id}/read`,
  notificationMarkAllRead: 'notifications/mark-all-read',
  BulkAddAchievements: 'user/bulk-achievement-upload',
  toggleFeaturedPost: (postId: string) => `post/feature/${postId}`,
  adminPostEdit: (id: string) => `post/admin/${id}`,
  deleteSection: (id: string) => `section/admin/${id}`,
  addSection: (id: string) => `section/admin/post/${id}`,
};
